<template>
    <h1>Cart</h1>
</template>

<script>
import CartItem from "./CartItem";

export default {
    name: "CartComponent",

    components: {
        'cart-item-component': CartItem,
    },

    data() {
        return {
            items: {},
            subtotal: 0,
            tax_gst: 0,
            tax_qst: 0,
            total: 0,
        }
    },

    methods: {
        addItem()
        {

        },

        clear()
        {

        },

        hasItem()
        {

        },

        initCart()
        {

        },

        loadItems()
        {

        },

        removeItem()
        {

        }
    }
}
</script>

<style scoped>

</style>
